export var reflow = function reflow(node) {
  return node.scrollTop;
};
export function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/transitions/utils.js
// module id = 318
// module chunks = 121